export default {
  login(email) {
    return new Promise((resolve, reject) => {
      $.post('/auth/login', {
        email
      }, resolve)
        .fail(reject)
    })
  },

  token(token, email) {
    return new Promise((resolve, reject) => {
      $.get('/auth/login/' + token, {
        email
      }, resolve)
        .fail(reject)
    })
  },
}
